import { memo } from 'react'
import type { JSX } from 'react'

import { ChannelAvatar, CheckboxCard, Flex, Text } from '@buffer-mono/popcorn'
import type { CheckedState } from '@buffer-mono/popcorn'

import type { ChannelNavChannel } from '~publish/components/PublishSidebar/useChannels'
import {
  getChannelAdditionalInfo,
  getChannelName,
} from '~publish/helpers/channels'
import { getChannelNameForDisplay } from '~publish/helpers/getChannelNameForDisplay'

import styles from './ChannelListItem.module.css'

const getChannelDescriptor = (channel: ChannelNavChannel): string => {
  const serviceName = getChannelName(channel.service)
  const additionalInfo = getChannelAdditionalInfo(channel)

  if (additionalInfo) {
    return `${serviceName} • ${additionalInfo}`
  }

  return serviceName
}

const ChannelListItem = ({
  channel,
  onChange,
  selected,
}: {
  channel: ChannelNavChannel
  onChange: (channelId: string, checked: CheckedState) => void
  selected: boolean
}): JSX.Element => {
  return (
    <CheckboxCard
      onCheckedChange={(checked): void => onChange(channel.id, checked)}
      checked={selected}
      className={styles.channelListItem}
    >
      <ChannelAvatar
        alt={getChannelNameForDisplay(channel)}
        channel={channel.service}
        src={channel.avatar}
        size="small"
      />
      <Flex direction="column" gap="3xs">
        <Text weight="medium">{getChannelNameForDisplay(channel)}</Text>
        <p className={styles.channelInfo}>{getChannelDescriptor(channel)}</p>
      </Flex>
    </CheckboxCard>
  )
}

export default memo(ChannelListItem)
